import { useEffect, useState } from 'react';
import { AlertTriangle, Boxes, Building2, ClipboardList, FileText, MapPin, MessageSquare, Users } from 'lucide-react';
import { api, type Resumo } from '../api';
import { useSessao } from '../sessao';

function saudacao() {
  const h = Number(new Intl.DateTimeFormat('pt-BR', { hour: 'numeric', hour12: false, timeZone: 'America/Sao_Paulo' }).format(new Date()));
  return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
}

const INDICADORES: { chave: keyof Resumo; rotulo: string; icone: typeof Boxes; alerta?: boolean }[] = [
  { chave: 'os_abertas', rotulo: 'OS em aberto', icone: ClipboardList },
  { chave: 'os_sla_vencido', rotulo: 'OS com SLA vencido', icone: AlertTriangle, alerta: true },
  { chave: 'chamados_novos', rotulo: 'Chamados aguardando triagem', icone: MessageSquare },
  { chave: 'contratos_ativos', rotulo: 'Contratos ativos', icone: FileText },
  { chave: 'clientes_ativos', rotulo: 'Clientes ativos', icone: Building2 },
  { chave: 'locais', rotulo: 'Parques', icone: MapPin },
  { chave: 'ativos', rotulo: 'Equipamentos no parque', icone: Boxes },
  { chave: 'tecnicos', rotulo: 'Técnicos com acesso', icone: Users },
];

export function Inicio() {
  const { usuario } = useSessao();
  const [resumo, setResumo] = useState<Resumo | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    api<Resumo>('/painel/resumo').then(setResumo).catch((e) => setErro(e.message));
  }, []);

  const vazio = resumo && INDICADORES.every((i) => Number(resumo[i.chave]) === 0);
  const primeiroNome = usuario?.nome.split(' ')[0];

  return (
    <>
      <span className="kicker">Início</span>
      <h1 className="titulo">
        {saudacao()}, <span>{primeiroNome}.</span>
      </h1>
      {erro && <p className="alerta" role="alert">{erro}</p>}
      <div className="grade-indicadores">
        {INDICADORES.map(({ chave, rotulo, icone: Icone, alerta }) => {
          const valor = resumo ? Number(resumo[chave]) : null;
          return (
            <div key={chave} className={`cartao indicador${alerta && valor ? ' em-alerta' : ''}`}>
              <div className="icone-tile"><Icone size={24} strokeWidth={1.7} aria-hidden /></div>
              <strong className="valor">{valor ?? '—'}</strong>
              <span className="rotulo">{rotulo}</span>
            </div>
          );
        })}
      </div>
      {vazio && (
        <div className="cartao aviso-vazio">
          <span className="pill-breve"><i aria-hidden /> base vazia</span>
          <p>
            O sistema está no ar e conectado ao banco, mas ainda sem dados de operação. Os números aparecem quando o extrator do Auvo
            começar a trazer clientes, equipamentos e OS, ou quando os primeiros cadastros forem feitos aqui.
          </p>
        </div>
      )}
      {resumo && <p className="nota">Atualizado em {new Date(resumo.gerado_em).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}.</p>}
    </>
  );
}
